import Dropzone from "dropzone";

Dropzone.autoDiscover = false;

$(document).ready(function () {
    /**
     * Entity Fetch
     */
    $('[data-entity-fetch]').on('click', function (e) {
        e.preventDefault();

        // abort if disabled
        if ($(this).hasClass('disabled')) {
            return;
        }

        var prefix = $(this).data('entity-fetch') || '';
        var url = $(this).data('entity-fetch-url');
        var _this = this;
        var entity_id_no = $('#' + prefix + 'id_no').val();

        if (!entity_id_no) {
            alert('please enter al the required details')
            // swal('', 'Please enter all the required details.', 'info');
            return;
        }

        $.ajax({
            url: url,
            dataType: 'json',
            delay: 250,
            type: 'GET',
            data: {
                filter: {
                    search: entity_id_no,
                },
                append: '',
                include: '',
                fields: 'id,name,nid_no,gender,email',
                per_page: 1
            },
            beforeSend: function () {
                toggleLoading($(_this), true);
            },
            complete: function () {
                toggleLoading($(_this), false);
            },
            success: function (results) {
                if (results.total) {
                    var entity = results.data[0];
                    console.log(entity)
                    var match_el = $('.entity-match');

                    match_el.find('.name').text(entity.name);
                    match_el.find('.nid_no').text(entity.nid_no);
                    match_el.find('.gender').text(entity.gender);
                    match_el.find('.email').text(entity.email);

                    match_el.find('[data-use-entity]')
                        .data('use-entity', entity.id)
                        .data('entity-name', entity.name);

                    $('.entity-no-match').hide();
                    $('.entity-form').hide();
                    match_el.slideDown();
                } else {
                    $('.entity-match').hide();
                    $('.entity-no-match').slideDown();
                    $('.entity-form').slideDown().trigger('change');
                    // bindSelectCustom($(this))
                }
            },
            error: function (xhr) {
                if (xhr.status == 422) {
                    showValidationErrorMsg(xhr);
                } else {
                    swal('Error!', 'An error occurred while fetching entity data.', 'error');
                }
            }
        });

    });

    $("[data-dropzone-url]").each(function () {
        var dropzone_url = $(this).data("dropzone-url");
        var data = $(this).data("dropzone-data") || {};
        var param_name = $(this).data("dropzone-param") || "file";
        var delete_url = $(this).data("dropzone-delete-url");
        var files = $(this).data("dropzone-files") || {};
        var max_files = $(this).data("dropzone-max-files") || null;
        var max_size = $(this).data("dropzone-max-size") || 2;
        var accepted =
            $(this).data("dropzone-accept") || "image/png, image/jpeg";
        var auto_process = !($(this).data("dropzone-delay-submit") || false);
        var parent_el = this;

        console.log('here');

        var dropzone_el = new Dropzone(this, {
            url: dropzone_url,
            paramName: param_name,
            autoProcessQueue: auto_process,
            dictResponseError: "Error uploading file!",
            dictDefaultMessage: "Drop files here to upload",
            dictFileTooBig:
                "File is too big ({{filesize}} MB). Max filesize: {{maxFilesize}} MB",
            dictInvalidFileType: "You can't upload files of this type.",
            maxFilesize: max_size,
            maxFiles: max_files,
            uploadMultiple: false,
            parallelUploads: 50,
            acceptedFiles: accepted,
            error: function (file, response) {
                var message = response;

                if (typeof message !== "string") {
                    message = message.error
                        ? message.error
                        : "Error uploading file!";
                }

                file.previewElement.classList.add("dz-error");
                var _ref = file.previewElement.querySelectorAll(
                    "[data-dz-errormessage]"
                );
                var _results = [];
                var _len = _ref.length;

                for (var _i = 0; _i < _len; _i++) {
                    var node = _ref[_i];
                    _results.push((node.textContent = message));
                }

                return _results;
            },
            init: function () {
                if (data) {
                    this.on("sending", function (file, xhr, formData) {
                        for (const key in data) {
                            if (data.hasOwnProperty(key)) {
                                var val = data[key];
                                var form_val = val;

                                // find dynamic value
                                if (
                                    typeof val === "object" &&
                                    val.hasOwnProperty("el")
                                ) {
                                    form_val = $(val.el).val();

                                    if (!form_val) {
                                        form_val = val.default;
                                    }
                                }

                                formData.append(key, form_val);
                            }
                        }
                    });
                }

                this.on("maxfilesexceeded", function (file) {
                    this.removeFile(file);
                    Swal.fire({
                        title: "Warning!",
                        text: "Maximum number of allowed files exceeded.",
                        confirmButtonText: "Ok",
                        icon: "warning",
                    });
                });

                this.on("success", function (file, response) {
                    file.id = response.id;
                    file.delete_url = response.delete_url;

                    if (
                        response.thumb &&
                        file.previewElement &&
                        file.previewElement.classList.contains(
                            "dz-file-preview"
                        )
                    ) {
                        if (response.type === "video") {
                            file.previewElement.classList.add(
                                "dz-image-preview"
                            );
                        }

                        file.thumb = response.thumb;
                        this.emit("thumbnail", file, file.thumb);
                    }
                });

                this.on("addedfile", function (file) {
                    // Create the remove button
                    var removeButton = Dropzone.createElement(
                        '<a class="dz-remove">Remove file</a>'
                    );

                    if (file.type === "video") {
                        file.previewElement.classList.add("dz-image-preview");
                    }

                    // Capture the Dropzone instance as closure.
                    var _this = this;
                    // Listen to the click event
                    removeButton.addEventListener("click", function (e) {
                        // Make sure the button click doesn't submit the form:
                        e.preventDefault();
                        e.stopPropagation();

                        // Remove the file preview.
                        if (typeof file.id !== "undefined") {
                            Swal.fire({
                                title: "Are you sure you want to remove this file?",
                                text: "You will not be able to undo this delete operation!",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonText: "Yes, Delete!",
                                cancelButtonText: "Cancel",
                            }).then(function (result) {
                                if (result.value) {
                                    //remove file extension
                                    var id = file.id;

                                    $.ajax({
                                        type: "DELETE",
                                        url: delete_url || file.delete_url,
                                        contentType: "application/json",
                                        beforeSend: function () {
                                            toggleLoading(
                                                $(removeButton),
                                                true
                                            );
                                        },
                                        complete: function () {
                                            toggleLoading(
                                                $(removeButton),
                                                false
                                            );
                                        },
                                        success: function (data) {
                                            _this.removeFile(file);
                                            notify(
                                                "Success!",
                                                "File" +
                                                file.name +
                                                " removed successfully.",
                                                "success"
                                            );
                                        },
                                        error: function (
                                            jqXHR,
                                            textStatus,
                                            errorThrow
                                        ) {
                                            if (jqXHR.status != 404) {
                                                notify(
                                                    "Error!",
                                                    "Error while removing file" +
                                                    file.name,
                                                    "danger"
                                                );
                                            } else {
                                                _this.removeFile(file);
                                            }
                                        },
                                    });
                                }
                            });
                        } else {
                            _this.removeFile(file);
                        }
                    });

                    // Add the button to the file preview element.
                    file.previewElement.appendChild(removeButton);
                });

                //add files to dropzone
                for (var i in files) {
                    var file = files[i];
                    file.accepted = true;

                    this.files.push(file);
                    this.emit("addedfile", file);
                    this.emit("thumbnail", file, file.thumb);
                    this.emit("complete", file);
                }
            },
        });
    });
});
